import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { MSCToken, MSCDayToken } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';

@Component({
  selector: 'mat-short-extrnl',
  templateUrl: './mat-short-extrnl.component.html',
  styleUrls: ['./mat-short-extrnl.component.css']
})
export class MatShortExtrnlComponent implements OnChanges {
  @ViewChild('childMSModal') public childMSModal: ModalDirective;
  @Input() MSCTokenArray:Array<MSCToken>;
  @Input() ShortageSource:string;
  
  editMSRow:MSCToken;
  editMSRowRef:MSCToken;  
  editMSHeader:string = '';
  editMSToken:string = '';
  mId:string = "";

  constructor(public _dataService:DataService) { }

  ngOnChanges() {
  }


  public showMSChildModal(_opToken: string, _param1: any, _param2: any): void {
    switch (_opToken) {
      case "rownew":
        this.editMSRow = new MSCToken(GenService.getGUID(),'',this.ShortageSource,'',(new Date()).getTime(),null,null,(new Date()).getTime());
        this.editMSToken = _opToken;
        this.editMSHeader = "Add Focus Area";
        break;
      case "rowedit":
        this.editMSRow = _param1.cloneSelf();
        this.editMSRowRef = _param1;
        this.editMSToken = _opToken;
        this.editMSHeader = "Edit Focus Area";

      break;
    }
    this.childMSModal.show();
  }

  dataMSEdited(){
    if(this.validateData() == true){
      switch(this.editMSToken){
        case "rownew":
            this.MSCTokenArray.push(this.editMSRow);
        break;
        case "rowedit":
          this.editMSRowRef.particulars = this.editMSRow.particulars;
          this.editMSRowRef.resolutionDate = this.editMSRow.resolutionDate;
          this.editMSRowRef.ownerName = this.editMSRow.ownerName;
          this.editMSRowRef.status = this.editMSRow.status
        break;
      }
      this.hideMSChildModal();
    }
  }

  validateData():boolean{
    return true;
  }
  getStatus(_id:string):string{
    if(_id)
      return this._dataService.getShrtgeFormStatus(_id)
    return '';
  }

  public hideMSChildModal(): void {
    this.childMSModal.hide();
  }

  public discardMSSaveData():void{
    this.childMSModal.hide();
  }

  removeRecord(_removeObj:MSCToken){
    let _index:number = this.MSCTokenArray.indexOf(_removeObj);
    if(_index >= 0){
      this.MSCTokenArray.splice(_index,1);
    }
  }

  getData(option) {
    if (option) return option
    return ''
  }
  getOwner(_ownr:string):string{
    if(_ownr){
      return this._dataService.getResponsiblePrsn(_ownr);
    }
    return ''
  }
  formatDateMS(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD/MMM/YY HH:mm:ss");
    }
    return '-';
  }

  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }
}
